export const translations = {
  en: {
    notFound: {
      errorCode: '404',
      errorMessage: "Oops! The page you are looking for doesn't exist.",
      backButton: 'Go back to Home',
    },
  },
  ro: {
    notFound: {
      errorCode: '404',
      errorMessage: 'Ups! Pagina pe care o căutați nu există.',
      backButton: 'Înapoi Acasă',
    },
  },
};
